module.exports = __webpack_public_path__ + "media/img/kim-logo2-b5f7d20cdcda931f7e1f55ed7279ac3f.jpg";